import React from "react";

import { Route, Routes, Navigate } from "react-router-dom";

import useDecodedParams from "Hooks/useDecodedParams";
import {
  selectFeatureEditPlanEnabled,
  selectFeatureUsageBasedBillingEnabled,
  selectFeatureVouchersEnabled,
  selectFeatureCarbonEmissionsDashboardEnabled
} from "Reducers/featureFlags/featureFlags.selectors";
import { organizationByDescriptionIdSelector } from "Reducers/organization";
import { useAppSelector } from "Store/hooks";

import CarbonEmissionsPage from "./carbonEmissions/Page";
import BillingDetailPage from "./details/Page";
import HistoryDetailPage from "./history/detail/Page";
import HistoryListPage from "./history/list/Page";
import OrganizationBilling from "./organizationBilling";
import OrganizationCommitment from "./organizationCommitment";
import Page from "./Page";
import PlanDetailsPage from "./plan/details/Page";
import PlanPage from "./plan/list/Page";
import SCAPage from "./SCA/Page";
import VoucherFormPage from "./vouchers/Form";
import VouchersListPage from "./vouchers/List";

const OrganizationBillingRoutes = () => {
  const { organizationId } = useDecodedParams();

  const editPlanEnabled = useAppSelector(selectFeatureEditPlanEnabled);
  const usageBasedBillingEnabled = useAppSelector(
    selectFeatureUsageBasedBillingEnabled
  );
  const vouchersEnabled = useAppSelector(selectFeatureVouchersEnabled);
  const carbonEmissionsDashboardEnabled = useAppSelector(
    selectFeatureCarbonEmissionsDashboardEnabled
  );

  const organization = useAppSelector(state =>
    organizationByDescriptionIdSelector(state, {
      organizationDescriptionId: organizationId
    })
  );

  const acceptableOrganization =
    !organization || organization?.hasLink("orders");

  const BaseRouteByUsageBasedBilling = usageBasedBillingEnabled
    ? OrganizationBilling
    : BillingDetailPage;
  return (
    <Page>
      <Routes>
        <Route path="history/:orderId" element={<HistoryDetailPage />} />
        <Route path="history" element={<HistoryListPage />} />
        <Route path="commitment" element={<OrganizationCommitment />} />

        {carbonEmissionsDashboardEnabled && (
          <Route path="carbon-emissions" element={<CarbonEmissionsPage />} />
        )}

        {vouchersEnabled && (
          <>
            <Route path="vouchers/add" element={<VoucherFormPage />} />
            <Route path="vouchers" element={<VouchersListPage />} />
          </>
        )}
        <Route
          path="plan/:subscriptionId"
          element={
            editPlanEnabled && !usageBasedBillingEnabled ? (
              <PlanDetailsPage />
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route path="plan" element={<PlanPage />} />
        <Route path="sca/:orderId" element={<SCAPage />} />
        {usageBasedBillingEnabled && (
          <Route path="details" element={<BillingDetailPage />} />
        )}
        <Route
          path=""
          element={
            acceptableOrganization ? (
              <BaseRouteByUsageBasedBilling />
            ) : (
              <Navigate to="/" />
            )
          }
        />
      </Routes>
    </Page>
  );
};

export default OrganizationBillingRoutes;
